module.exports = __webpack_public_path__ + "img/060_Mond_Mars_thb.03c903bd.jpg";